module.exports = __webpack_public_path__ + "static/cj-2e4f3fc59bd7ec8a7b9e8998fc1f6b2a.png";